<template>
  <ul id="faqacc" class="accordion" 
    data-accordion data-multi-expand="true" 
    data-allow-all-closed="true">
    <template v-for="(question, index) in questoes">
      <li :class="{'accordion-item': true, 'is-active': isExpanded(index)}"
        v-if="question.visible" 
        @click.prevent="toggleAccordion(index)"
        data-accordion-item>
          <a href="#" class="accordion-title">
            {{ question.docfaq_pergunta }}
          </a>
          <div class="accordion-content" :id="`item${index}`" >
            <p>
              <span style="white-space: pre-wrap;" 
                v-html="question.docfaq_resposta"></span>
            </p>
          </div>
      </li>
    </template>
  </ul>
</template>

<script>
import $ from 'jquery';
import { ref } from 'vue';

export default {
  props:["questoes"],
  setup () {

    const expandedItems = ref([]);

    const toggleAccordion = (index) => {
      const selector = `#item${index}`;
      const $content = $(selector);
      const position = expandedItems.value.indexOf(index);
      if (position > -1) {
        expandedItems.value.splice(position, 1);
        $content.slideUp(() => { });
      } else {
        expandedItems.value.push(index);
        $content.slideDown(() => { });
      }
    };

    const isExpanded = (index) => expandedItems.value.includes(index);
    
    return {
      toggleAccordion,
      isExpanded
    }
  }
}
</script>

<style scoped>
.accordion-content{
  background-color: transparent;
  border: transparent;
}

.accordion-content p {
  font-family: "PT Sans";
  color: #656565;
  line-height: 2;
  padding-left: 12px;
}
.accordion-title:before {
  font-size: 25px;
  margin-top: -19px;
}
.accordion-title{
  border: transparent;
  color: #414545;
  font-size: 15px;
  line-height: 1.5;
  padding: 11px 70px 11px 0px;
  border: transparent;
  border-bottom: 1px solid #a7a5a5;
  font-family: 'Montserrat';
}

.accordion-title:hover, .accordion-title:focus {
  background-color: transparent;
  color: #707475;
}

:last-child:not(.is-active)>.accordion-title {
  border-bottom: transparent;
}
:last-child>.accordion-content:last-child {
  border-bottom: transparent;
}

.accordion-title, .accordion-item{
  background-color: transparent;
}


.accordion{
  background-color: transparent;
}

@media (max-width: 676px) {

  .accordion{
    background-color: transparent;
  }

  .accordion:first-of-type {
    border-top: 1px solid #a7a5a5;
  }

  .accordion:last-of-type {
    border-bottom: 1px solid #a7a5a5;
    margin-bottom: 10px;
  }

  .accordion-title {
    margin-left: 0;
    line-height: 1.2;
    font-family: "Montserrat";
    font-size: 13px;
    padding-right: 50px;
    padding-top: 8px;
    padding-bottom: 8px;
    color: #414545;
    background-color: transparent;
  }

  .accordion-title:before {
    right: 5px;
  }
  .accordion-content {
    border: transparent;
    padding-right: 0;
    padding-left: 0;
  }
  .accordion-content p {
    font-size: 14px;
    line-height: 1.9;
    padding-left: 0;
  }
}

</style>